export default {
  ultimaCargaInterval: null,

  verificarEstadoUltimaCarga(id) {
    $.ajax({
      url: 'api/estado_carga_externa/' + id,
      success: (response) => {
        if (response && response.estado !== 'CARGANDO') {
          this.ultimaCargaInterval = null;
          window.location.reload();
        }
      }
    })
  },

  initUltimaCargaInterval() {
    const $importando = $('.js-importando-archivo');
    if ($importando.length > 0) {
      this.ultimaCargaInterval = setInterval(() => {
        const id = $importando.data('id');
        this.verificarEstadoUltimaCarga(id);
      }, 3500);
    }
  },

  check() {
    this.initUltimaCargaInterval();
  }
}
